import React, { useState } from "react";
import "../styles/Login.css";
import { login, registerUser } from "../services/authService";

const Login = ({ onClose }) => {
  const [isSignup, setIsSignup] = useState(false);
  const [formData, setFormData] = useState({
    username: "",
    password: "",
    confirmPassword: "",
  });
  const [errorMsg, setErrorMsg] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const toggleForm = (signupMode) => {
    setIsSignup(signupMode);
    setFormData({ username: "", password: "", confirmPassword: "" });
    setErrorMsg("");
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validate password confirmation for sign up
    if (isSignup && formData.password !== formData.confirmPassword) {
      setErrorMsg("Passwords do not match.");
      return;
    }

    setIsLoading(true);
    try {
      if (isSignup) {
        // Call registerUser API; it should create the account and return tokens if needed
        const response = await registerUser(
          formData.username,
          formData.password
        );
        console.log("Registered successfully:", response);
      } else {
        // Call login API to obtain tokens
        const response = await login(formData.username, formData.password);
        console.log("Logged in successfully:", response);
      }
      setErrorMsg("");
      onClose(); // Close modal on successful login/sign up
    } catch (error) {
      console.error(error);
      setErrorMsg(
        error.response?.data?.message || "An error occurred. Please try again."
      );
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="login-modal">
      <div className="login-box">
        <span className="close-btn" onClick={onClose}>
          &times;
        </span>

        {/* Toggle Buttons */}
        <div className="toggle-buttons">
          <button
            className={!isSignup ? "active" : ""}
            onClick={() => toggleForm(false)}
          >
            Login
          </button>
          <button
            className={isSignup ? "active" : ""}
            onClick={() => toggleForm(true)}
          >
            Sign Up
          </button>
        </div>

        <h2>{isSignup ? "Sign Up" : "Login"}</h2>
        {errorMsg && <div className="error-message">{errorMsg}</div>}

        <form onSubmit={handleSubmit}>
          <input
            type="text"
            name="username"
            value={formData.username}
            onChange={handleChange}
            placeholder="Username"
            required
          />
          <input
            type="password"
            name="password"
            value={formData.password}
            onChange={handleChange}
            placeholder="Password"
            required
          />
          {isSignup && (
            <input
              type="password"
              name="confirmPassword"
              value={formData.confirmPassword}
              onChange={handleChange}
              placeholder="Confirm Password"
              required
            />
          )}
          <div className="submit-container">
            <button type="submit" disabled={isLoading}>
              {isLoading ? "Please wait..." : isSignup ? "Sign Up" : "Login"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Login;
